// src/components/ContactBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ContactBanner.css";

const ContactBanner = () => {
  return (
    <section className="contact-banner">
      <Container>
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">Contact Us</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">Contact</span>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactBanner;
